(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shp-collection-availability"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.querySelector('[data-shp-collection-config]');
  if (!config) return;
  const cache = new Map();
  const queue = new Map();
  const pending = new Set();
  let active = 0;
  let scanTimer;
  let flushTimer;
  function keyFor(card) {
    const link = card.querySelector('.productitem--title a[href]');
    if (!link) return null;
    const url = new URL(link.href, location.origin);
    const match = url.pathname.match(/\/products\/([^/]+)/);
    if (!match) return null;
    let id = card.getAttribute('varian-id');
    if (!card.hasAttribute('data-usf-pid')) {
      const swatch = card.querySelector('input[name="swatch"]:checked');
      const source = card.querySelector('[data-swatch-data]');
      if (swatch && source) {
        try {
          const data = JSON.parse(source.textContent);
          const matches = data.variants.filter(v => v[data.swatchOptionKey] === swatch.value);
          id = String((matches.find(v => v.available) || matches[0])?.id || '');
        } catch { return null; }
      }
      if (!id) id = card.querySelector('[data-shp-variant]')?.dataset.shpVariant;
    }
    id = id || url.searchParams.get('variant') || '0';
    if (!/^\d+$/.test(id)) return null;
    return decodeURIComponent(match[1]) + '~' + id;
  }
  function apply(card, key, html) {
    if (!card.isConnected || keyFor(card) !== key) return;
    if (!card.hasAttribute('data-usf-pid') && card.querySelector('input[name="swatch"]:checked')) {
      for (const link of card.querySelectorAll('a[href*="variant=undefined"]')) {
        const url = new URL(link.href, location.origin);
        url.searchParams.set('variant', key.split('~').pop());
        link.setAttribute('href', url.pathname + url.search + url.hash);
      }
    }
    let host = card.querySelector('[data-shp-availability-host], .productitem__stock-level');
    if (!host) {
      host = document.createElement('div');
      host.dataset.shpAvailabilityHost = '';
      host.className = 'productitem__stock-level';
      host.setAttribute('aria-live', 'polite');
      const info = card.querySelector('.productitem--info');
      const description = info?.querySelector('.productitem--description');
      if (!info) return;
      info.insertBefore(host, description || null);
    }
    if (host.dataset.shpKey === key && host.innerHTML === html) return;
    host.innerHTML = html;
    host.dataset.shpKey = key;
  }
  function unknown() {
    const el = document.createElement('div');
    el.className = 'shp-availability';
    el.dataset.shpStatus = 'unknown';
    el.textContent = config.dataset.unconfirmed;
    return el.outerHTML;
  }
  function scan() {
    for (const card of document.querySelectorAll('[data-product-item]')) {
      const key = keyFor(card);
      if (!key) continue;
      if (!card.hasAttribute('data-usf-pid') && !cache.has(key)) {
        const stock = card.querySelector('[data-shp-variant]');
        if (stock && key.endsWith('~' + stock.dataset.shpVariant)) {
          cache.set(key, stock.outerHTML);
        }
      }
      if (cache.has(key)) apply(card, key, cache.get(key));
      else {
        const host = card.querySelector('[data-shp-availability-host], .productitem__stock-level');
        if (host && host.dataset.shpKey !== key && host.hasChildNodes()) host.replaceChildren();
        if (!pending.has(key)) queue.set(key, true);
      }
    }
    clearTimeout(flushTimer);
    flushTimer = setTimeout(flush, 80);
  }
  async function load(keys) {
    const url = new URL(config.dataset.searchUrl, location.origin);
    url.searchParams.set('view', 'shp-availability');
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', keys.join('|'));
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const response = await fetch(url, { signal: AbortSignal.timeout(10000), credentials: 'same-origin' });
    if (!response.ok) throw new Error('Availability request failed');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const results = new Map([...doc.querySelectorAll('[data-shp-result]')].map(el => [el.dataset.shpResult, el.innerHTML]));
    for (const key of keys) cache.set(key, results.get(key) || unknown());
  }
  async function flush() {
    if (active >= 2 || !queue.size) return;
    const keys = [...queue.keys()].slice(0, 20);
    keys.forEach(key => { queue.delete(key); pending.add(key); });
    active++;
    flush();
    try {
      try { await load(keys); } catch { await load(keys); }
    } catch {
      keys.forEach(key => cache.set(key, unknown()));
    } finally {
      keys.forEach(key => pending.delete(key));
      active--;
      scan();
    }
  }
  function schedule() {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(scan, 100);
  }
  function start() {
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'varian-id'] });
    scan();
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('change', event => {
      if (event.target.matches('input[name="swatch"]')) schedule();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shp-eta-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
  let opener;
  document.addEventListener('click', event => {
    const trigger = event.target.closest?.('[data-shp-eta-trigger]');
    if (!trigger) return;
    const dialog = document.getElementById('shp-eta-dialog');
    if (!dialog) return;
    event.preventDefault();
    event.stopPropagation();
    const kind = trigger.dataset.shpEtaTrigger === 'in_stock' ? 'inStock' : 'backInStock';
    const heading = dialog.querySelector('#shp-eta-heading');
    const description = dialog.querySelector('#shp-eta-description');
    heading.textContent = heading.dataset[kind];
    description.textContent = description.dataset[kind];
    dialog.querySelector('#shp-eta-date').textContent = trigger.textContent.trim();
    opener = trigger;
    if (!dialog.open) dialog.showModal();
  }, true);
  function bind() {
    const dialog = document.getElementById('shp-eta-dialog');
    if (!dialog) return;
    dialog.addEventListener('click', event => {
      if (event.target.closest?.('[data-shp-eta-close]')) dialog.close();
      else if (event.target === dialog) {
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      }
    });
    dialog.addEventListener('close', () => {
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
})();
  } catch(e) { console.error(e); }
})();

})();
